module.exports = __webpack_public_path__ + "static/logo_white-05c3aee620642b98b89ffe0e9837995b.png";